import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  DASHBOARD: {
    id: 'Dashboard.dashboard',
    defaultMessage: 'Dashboard',
    description: '[Type: Label][Vis.: low] - Dashboards section of nav bar',
  },
});

const Dashboard = () => {
  const url = createURL('/dashboard/', { ut_source: 'header' });
  const title = t(COPY.DASHBOARD);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.DASHBOARD} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.DASHBOARD} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default Dashboard;
export { Dashboard };
